import { User } from "./user";
import { UserSearchPreferences } from "./user-search-preferences";

export class UserProfile {
  constructor(private user: User, private preferences: UserSearchPreferences) {}

  public getPreferences(): UserSearchPreferences {
    return this.preferences;
  }

  public getUser(): User {
    return this.user;
  }
}
